var canonicalise = require('topics/topic-path-utils').canonicalise;

module.exports = function ValueCache() {
    var cache = {};

    this.get = function(path) {
        return cache[canonicalise(path)];
    };

    this.put = function(path, value) {
        cache[canonicalise(path)] = value;
    };

    this.remove = function(selector) {
        for (var k in cache) {
            if (selector.selects(k)) {
                delete cache[k];
            }
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/features/topic-control/value-cache.js
// module id = 996
// module chunks = 1